/* eslint-disable react/no-unused-state */
import React from "react";
import { API_URL } from "../../constants/api";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { SECTIONS, standardDateFormat } from "../../constants/appConstants";
import {
  IsSectionVisible,
  GetUserConfiguration,
  removeDuplicates,
  sortArray,
  PaperComponent,
  getGroupedParentChildList,
} from "../../utils/helper";
import { apiBatchRequest, apiRequest, apiRequestAsync } from "../../utils/api_service";
import {
  AppBar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import PaginationControlled from "../common/pagination/pagination";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { convertToLocalDate } from "../../utils/date";
import TableHeaderWithFilter from "../common/table-header-filter";
import { uniqBy } from "lodash";
import { getArrayIndex } from "../../utils/lodash";
import { convertIntoDDFormat } from "../../utils/generic";
import { Reply } from "@material-ui/icons";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import store from "../../store/appStore";
import * as actionType from "../../store/layout/actionTypes";
import moment from "moment";
/**
 * React Component used for Rendering Communication Logs
 */
class CommunicationTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      communicationLogs: [],
      pageNo: 0,
      rowsPerPagination: 25,
      viewAll: false,
      selectedData: "",
      isShowColFilter: this.props.isShowColFilter,
      colFilteredObj: [
        { keyName: "emailSentDateTime", value: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}`, filterType: "dateRange" }
      ],
      sortByColKey: "",
      sourceData: this.props.sourceData,
      reload: false,
      selectedSource: [],
      selectedIds: {emailSentDateTime: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}` },
      refreshFilteredObj: false,
      keepFilterData: false,
      clearData: false,
      header: "",
      numberOfRecord: 0
    };
  }

   /** Component Did mount Call when first time component loads */
   componentDidMount() {
    //fetch list data
    this.getMasterData();
    this.getCommunicationLogs();
  }


  /** componentWillReceiveProps */
  componentWillReceiveProps(newProps) {
    const { reload, colFilteredObj, refreshFilteredObj } = this.state;
    if (newProps.isRecordSaved != this.props.isRecordSaved) {
      // Getting Communication Logs
      this.getCommunicationLogs();
      this.setState({
        keepFilterData: true,
        reload: !reload,
        selectedSource: colFilteredObj,
        clearData: false,
      });
    }

    if (newProps.restPage != this.props.restPage) {
      this.resetPage();
    }

    if (newProps.reloadCommTable != this.props.reloadCommTable) {
      this.clearFilter();
    }

    if (newProps.isShowColFilter != this.props.isShowColFilter) {
      this.setState({
        isShowColFilter: newProps.isShowColFilter, colFilteredObj: [],
        clearData: true,
        refreshFilteredObj: !refreshFilteredObj,
        sortByColKey: "",
        selectedIds: {},
      });
    }
  }
  
 
  /** Reset Page */
  resetPage = () => {
    const { reload } = this.state;

    this.setState(
      {
        colFilteredObj: [
          { keyName: "emailSentDateTime", value: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}`, filterType: "dateRange" }
        ],
        selectedIds: {emailSentDateTime: `${moment().add(-2, "month").startOf("month").format(standardDateFormat)}-${moment().endOf("month").format(standardDateFormat)}` },
        reload: !reload,
        refreshData: true
      },
      () => {
        this.getCommunicationLogs();
      }
    );
    
  };

  /** clear selected filters */
  clearFilter = () => {
    const { refreshFilteredObj } = this.state;
    this.setState({
      colFilteredObj: [],
      clearData: true,
      refreshFilteredObj: !refreshFilteredObj,
      sortByColKey: "",
      selectedIds: {},
    },
    () => {
      this.getCommunicationLogs();
    })
  }


  getMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.Communication.GetCommunicationMaster,
        key: "communicationMaster"
      }
    ]).then(({communicationMaster}) => {
      const tenantMaster = uniqBy(
        convertIntoDDFormat(
          communicationMaster.data.filter(x=> x.DataKey === "TenantList") || [],
          "DataValue",
          "DataLabel"
          ),
          (x) => x.value
        );
        this.setState({
          tenantMaster
        })
    })
  }

 

  /**
   * Method for getting Mass Communication List from Server
   */
  getCommunicationLogs = () => {
    const { reload, colFilteredObj, pageNo, rowsPerPagination } = this.state;
    const { sourceData } = this.props
    const userDetails = GetUserConfiguration();
    const accessGroupId = userDetails?.groups[0].accessGroupId;
    const dateFilter = colFilteredObj.filter(f => f.keyName == "emailSentDateTime")[0]
    ?.value;
    let fromDate = "";
    let toDate = "";
    if (dateFilter && dateFilter.length > 0) {
      fromDate = dateFilter.split("-")[0] === "" || dateFilter.split("-")[0] === null || dateFilter.split("-")[0] === "null" ? "" : dateFilter.split("-")[0];
      toDate = dateFilter.split("-")[1] === "" || dateFilter.split("-")[1] === null || dateFilter.split("-")[1] === "null" ? "" : dateFilter.split("-")[1];
    }

    const dataCenters =
    colFilteredObj
      .filter(f => f.keyName == "dataCenters")[0]
      ?.value.toString() || "All";
    let propertyId = "";
    if (dataCenters && dataCenters.length > 0) {
        dataCenters.split(",").map(function(r) {
          if (r != "All") {
            propertyId +=
              sourceData.filter(f => f.DataCenter == r)[0]?.DataCenterId + ",";
          } else propertyId = "";
        });
        if (propertyId.slice(-1) == ",") {
          propertyId = propertyId.slice(0, -1);
        }
    }

    const communicationCode = colFilteredObj.filter(f => f.keyName == "communicationCode")[0]
    ?.value;
    const emailSubject = colFilteredObj.filter(f => f.keyName == "emailSubject")[0]
    ?.value;
    const emailSentBy = colFilteredObj.filter(f => f.keyName == "requesterEmailID")[0]
    ?.value;

    const tenantName = colFilteredObj.filter(f => f.keyName == "tenantName")[0]
    ?.value;

    const selectedAttachment = colFilteredObj.filter(f => f.keyName == "attachment")[0]
    ?.value?.join(",");
    let attachment = "";
    if (selectedAttachment && selectedAttachment.length > 0) {
      selectedAttachment.split(",").map(function(r) {
        if (r != "All") {
          attachment += r;
        } else attachment = "";
      });
      if (attachment.slice(-1) == ",") {
        attachment = attachment.slice(0, -1);
      }
  }

    const params = {
      accessGroupId: accessGroupId,
      startDate: fromDate,
      endDate: toDate,
      pageSize: rowsPerPagination,
      pageNumber: (pageNo + 1),
      propertyId: propertyId,
      communicationCode,
      emailSubject,
      emailSentBy,
      attachment,
      tenantName
    }
    if (accessGroupId) {
      apiRequest({
        url:
          API_URL.Communication.GetCommunicationLogByGroup,
          params
      }).then(({ data: response }) => {
      
        // Getting Grouped List based on Communication ParentId
        const groupedList = getGroupedParentChildList(response.communicationData, "parentId", "communicationLogID", "asc");
        this.setState({
          communicationLogs: groupedList,
          keepFilterData: true,
          reload: !reload,
          selectedSource: colFilteredObj,
          clearData: false,
          numberOfRecord: response.recordCount?.length === 1 ? response.recordCount[0] : 0
        });
      });
    }
  };

  /**
   * set the data when click on count
   * @param {*} viewAll 
   * @param {*} selectedData 
   */
  handleViewAllData = (viewAll = false, selectedData, header) => {
    this.setState({
      viewAll: viewAll,
      selectedData: selectedData,
      header: header
    });
  };

  /**
   * Handle Pagination Row count per page
   * @param {*} pageNo 
   * @param {*} rowsPerPagination 
   */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination }, () => {
      this.getCommunicationLogs();
    });
  };

  /**
   * Update Inline column filter for communication List
   * @param {*} key 
   * @param {*} value 
   * @param {*} filterType 
   */
  updateColumnFilter = (key, value = "", filterType, bitValue,  obj) => {
    const { colFilteredObj, selectedIds, clearData } = this.state;
    const perviousColFilteredObj = [...colFilteredObj]
    const index = getArrayIndex(colFilteredObj, { keyName: key });
    if (index !== -1) {
      colFilteredObj[index] = {
        keyName: key,
        value,
        filterType: filterType || "string",
      };
      key &&
        this.setState({
          colFilteredObj: colFilteredObj,
          sortByColKey: value ? key : "",
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        }, () => {
          if (clearData != true) {          
            if ((obj?.filterType === undefined && (value?.length >= obj?.maxLength || (value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value && value?.length == 0))) || (obj?.filterType !== undefined && obj?.maxLength === undefined && value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value)) {
              this.getCommunicationLogs();
            }
          }
        });
    } else {
      key &&
        this.setState({
          colFilteredObj: [
            ...colFilteredObj,
            { keyName: key, value, filterType: filterType || "string" },
          ],
          sortByColKey: value ? key : "",
          selectedIds: { ...selectedIds, [key]: value },
          pageNo: 0
        }, () => {
          if (clearData != true) {  
            if ((obj?.filterType === undefined && (value?.length >= obj?.maxLength || (value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value && value?.length == 0))) || (obj?.filterType !== undefined && obj?.maxLength === undefined && value !== perviousColFilteredObj?.find(x=> x.keyName === key)?.value)) {
              this.getCommunicationLogs();
            }
          }
        });
    }
  };

  /**
   * Gets Email recipients for Selected Item.
   * @param {*} item 
   * @param {*} reply 
   */
  getEmailLogRecipients = (item, reply, mainContent) => {
    if (item.communicationLogID) {
      const userDetails = GetUserConfiguration();
      const accessGroupId = userDetails?.groups[0].accessGroupId;
      apiRequest({
        url:
          API_URL.Communication.GetCommunicationLogRecipient +
          "?communicationId=" +
          item.communicationLogID + "&accessGroupId=" +
          accessGroupId
      }).then(({ data }) => {
        item.emailRecipients = data;
        this.props.openViewDialog(item, reply, mainContent);
        this.updateNotificationPanel();
      });
    }
  }

  /** Update notification panel */
  updateNotificationPanel = () => {

    apiRequestAsync({
      url: API_URL.Notification.List,
      key: "pendingNotifications"
    }).then((pendingNotifications) => {
      let sorted = [];
      if (pendingNotifications.success) {
        sorted = pendingNotifications?.data?.sort((a, b) => {
          const aDate = new Date(a.createdOn);
          const bDate = new Date(b.createdOn);
          return bDate.getTime() - aDate.getTime();
        });
      }
      store.dispatch({
        type: actionType.GET_NOTIFICATION_DATA,
        payload: sorted
      });
    });
  }
  

  /**
   * Return Icon based on Communication state open/Closed
   * @param {*} id 
   * @returns 
   */
  getIcon(id) {
    const { openCommunications } = this.state;
    const groupDataList = openCommunications || [];
    let upIcon = false;
    groupDataList.map((item) => {
      if (item == id) {
        upIcon = true;
      }
    });
    return upIcon;
  }

  /**
   * Collapse Communication
   * @param {*} parentID 
   */
  closeChildCommunication = (parentID) => {
    const { openCommunications } = this.state;
    let dataList = openCommunications || [];
    dataList.map((item) => {
      if (item === parentID) {
        dataList = dataList.filter((item1) => item1 !== item);
      }
    });
    this.setState({ openCommunications: dataList });
  };

  /**
   * Open Communication
   * @param {*} parentID 
   */
  openChildCommunication = (parentID) => {
    const { openCommunications } = this.state;
    const defaultDataList = openCommunications || [];
    defaultDataList.push(parentID);

    this.setState({ openCommunications: defaultDataList });
  };


  render() {
    const {
      communicationLogs,
      isShowColFilter,
      sourceData,
      colFilteredObj,
      viewAll,
      selectedData,
      clearData,
      refreshFilteredObj,
      selectedIds,
      reload,
      keepFilterData,
      selectedSource,
      rowsPerPagination,
      pageNo,
      header,
      tenantMaster,
      numberOfRecord
    } = this.state;

    const isCommunicationSectionVisible = IsSectionVisible(
      SECTIONS.COMMUNICATION,
      SECTIONS.COMMUNICATION_LIST
    );

    const isReplyCommunicationSectionVisible = IsSectionVisible(
      SECTIONS.COMMUNICATION,
      SECTIONS.REPLY_COMMUNICATION,
      SECTIONS.ADD_EDIT
    );

    const optionsListForDataCenter = uniqBy(
      convertIntoDDFormat(sourceData || [], "DataCenter", "DataCenter"),
      (x) => x.id
    );

    // eslint-disable-next-line no-unused-vars
    const tenantMasterList = uniqBy(
      convertIntoDDFormat(tenantMaster || [], "value", "value"),
      (x) => x.id
    );

    const filterList = communicationLogs;

    return (
      <div className={"col-xs-12"} >
        <div className={"communication-list-table-div"}>
          {isCommunicationSectionVisible ? (
            <table
              className={"communication-list-table"}
              style={{ fontWeight: "200 !important" }}
            >
              <thead>
                <tr
                  className={"blue-cust-title"}
                  style={{ borderTop: "3px solid #FFFFFF" }}
                >
                  <th
                    colSpan={10}
                    style={{
                      fontSize: "15px",
                      textAlign: "center",
                      lineHeight: "25px",
                    }}
                  >
                    {"Communication\r"}
                  </th>
                </tr>
                <TableHeaderWithFilter
                  clearData={clearData}
                  refreshFilteredObj={refreshFilteredObj}
                  selectedId={selectedIds}
                  reload={reload}
                  keepFilterData={keepFilterData}
                  selectedSource={selectedSource}
                  isDefaultFilter
                  columnData={[
                    {
                      headerClass: "w-3",
                      colName: " ",
                      keyName: "parent",
                      isHideFilter: true
                    },
                    {
                      headerClass: "w-15",
                      colName: "Communication #",
                      keyName: "communicationCode",
                      maxLength: 3
                    },
                    {
                      headerClass: "w-5",
                      colName: "Data Center",
                      keyName: "dataCenters",
                      filterType: "multiSelect",
                      width: "80px",
                      selectedIds: colFilteredObj.dataCenters,
                      optionsList: optionsListForDataCenter,
                    },
                    {
                      headerClass: "w-15",
                      colName: "Tenant Name",
                      keyName: "tenantName",
                      maxLength: 3,
                      trim:  false
                    },
                    {
                      headerClass: "w-30",
                      colName: "Subject",
                      keyName: "emailSubject",
                      maxLength: 3,
                      trim:  false
                    },
                    {
                      headerClass: "w-12",
                      colName: "No. of Recipients",
                      isHideFilter: true,
                    },
                    {
                      headerClass: "w-35",
                      colName: "Sent By",
                      keyName: "requesterEmailID",
                      maxLength: 3
                    },
                    {
                      headerClass: "w-15",
                      colName: "Sent On",
                      keyName: "emailSentDateTime",
                      filterType: "dateRange",
                    },
                    {
                      headerClass: "w-2",
                      colName: "Attachment",
                      keyName: "attachment",
                      width: "80px",
                      filterType: "multiSelect",
                      optionsList: [
                        { id: "No", value: "No" },
                        { id: "Yes", value: "Yes" },
                      ],
                    },
                    {
                      headerClass: "w-5",
                      colName: "Action",
                      isHideFilter: true,
                    },
                  ]}
                  isShowFilter={isShowColFilter}
                  onChangeFilter={this.updateColumnFilter}
                />
              </thead>
              <tbody>
                {filterList && filterList.length > 0 ? (
                  (
                    (rowsPerPagination > 0 && filterList) || []
                  ).map((item, index) => (<>
                    <tr key={"communication" + index} >
                      <td>{item.childData.length > 0 && item.key != "" ? (
                        this.getIcon(item.key) == true ? (
                          <Tooltip title={"Collapse"}>
                            <ArrowDropUpIcon
                              onClick={() =>
                                this.closeChildCommunication(item.key)}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        ) : (
                          <Tooltip title={"Expand "}>
                            <ArrowDropDownIcon
                              onClick={() =>
                                this.openChildCommunication(item.key)}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        )
                      ) : null}
                      </td>
                      <td>{item.communicationCode}</td>
                      <td style={{ textAlign: "center" }}>
                        {item.dataCenters == null ? (
                          "-"
                        ) : (
                          <>
                            <span
                              className={"underline"}
                              style={{
                                cursor: "pointer",
                                fontSize: "0.7rem",
                              }}
                              onClick={() =>
                                this.handleViewAllData(
                                  true,
                                  item.dataCenters,
                                  "Data Centers"
                                )}
                            >
                              {
                                removeDuplicates(item.dataCenters.split(","))
                                  .length
                              }
                            </span>
                          </>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.tenantName == null ? (
                          "-"
                        ) : (
                          <>
                            <span
                              className={"underline"}
                              style={{
                                cursor: "pointer",
                                fontSize: "0.7rem",
                              }}
                              onClick={() =>
                                this.handleViewAllData(
                                  true,
                                  item.tenantName,
                                  "Tenant Name"
                                )}
                            >
                              {
                                removeDuplicates(item.tenantName.split(","))
                                  .length
                              }
                            </span>
                          </>
                        )}
                      </td>
                      <td>{item.emailSubject}</td>
                      <td
                        style={{ textAlign: "right", paddingRight: "1.5rem" }}
                      >
                        {item.emailRecipientsCount}
                      </td>
                      <td style={{ paddingLeft: "0.2rem" }}>
                        {item.requesterEmailID == null
                          ? "-"
                          : item.requesterEmailID}
                      </td>
                      <td>
                        {item.emailSentDateTime == null
                          ? "-"
                          : convertToLocalDate(item.emailSentDateTime)}
                      </td>
                      <td>{item.attachment == null ? "-" : item.attachment}</td>
                      <td style={{ textAlign: "center" }}>
                        <span style={{ display: "flex"}}>
                          <Tooltip
                            title={"view"}
                            onClick={() => {
                              this.setState({
                                communicationId: item.communicationLogID,
                                data: item,
                                reply: false
                              });
                              this.getEmailLogRecipients(item, false, item);
                            }}
                          >
                            <IconButton size={"small"}>
                              <VisibilityIcon size={"small"} />
                            </IconButton>
                          </Tooltip>
                          {isReplyCommunicationSectionVisible === true && <Tooltip
                            title={"Reply"}
                            onClick={() => {
                              this.setState({
                                communicationId: item.communicationLogID,
                                data: item,
                                reply: true
                              });
                              this.getEmailLogRecipients(item, true, item);
                            }}
                                                                          >
                            <IconButton size={"small"}>
                              <Reply size={"small"} />
                            </IconButton>
                                                                          </Tooltip>}
                        </span>
                      </td>
                    </tr>
                    {this.getIcon(item.key) == true ?
                      item.childData.map((child, ci) => (
                        <tr key={"communication" + ci} className={child.isInternalUser === 0 ? "customer-reply" : ""}>
                          <td> </td>
                          <td>&nbsp;&nbsp;{child.communicationCode}</td>
                          <td style={{ textAlign: "center" }}>
                            {child.dataCenters == null ? (
                              "-"
                            ) : (
                              <>
                                <span
                                  className={"underline"}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "0.7rem",
                                  }}
                                  onClick={() =>
                                    this.handleViewAllData(
                                      true,
                                      child.dataCenters,
                                      "Data Centers"
                                    )}
                                >
                                  {
                                    removeDuplicates(child.dataCenters.split(","))
                                      .length
                                  }
                                </span>
                              </>
                            )}
                          </td>
                          <td style={{ textAlign: "center" }}>
                                {child.tenantName == null ? (
                                  "-"
                                ) : (
                                  <>
                                    <span
                                      className={"underline"}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "0.7rem",
                                      }}
                                      onClick={() =>
                                        this.handleViewAllData(
                                          true,
                                          child.tenantName,
                                          "Tenant Name"
                                        )}
                                    >
                                      {
                                        removeDuplicates(child.tenantName.split(","))
                                          .length
                                      }
                                    </span>
                                  </>
                                )}
                          </td>
                          <td>{child.emailSubject}</td>
                          <td
                            style={{ textAlign: "right", paddingRight: "1.5rem" }}
                          >
                            {child.emailRecipientsCount}
                          </td>
                          <td style={{ paddingLeft: "0.2rem" }}>
                            {child.requesterEmailID == null
                              ? "-"
                              : child.requesterEmailID}
                          </td>
                          <td>
                            {child.emailSentDateTime == null
                              ? "-"
                              : convertToLocalDate(child.emailSentDateTime)}
                          </td>
                          <td>{child.attachment == null ? "-" : child.attachment}</td>
                          <td>
                            <Tooltip
                              title={"view"}
                              onClick={() => {
                                this.setState({
                                  communicationId: child.communicationLogID,
                                  data: child,
                                  reply: false
                                });
                                this.getEmailLogRecipients(child, false, item);
                              }}
                            >
                              <IconButton size={"small"}>
                                <VisibilityIcon size={"small"} />
                              </IconButton>
                            </Tooltip>

                          </td>
                        </tr>
                      ))
                      : null}
                                          </>
                  ))
                ) : (
                  <tr>
                    <td style={{ textAlign: "center" }} colSpan={10}>
                      {"No data available\r"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : (
            <></>
          )}
        </div>
        {numberOfRecord && numberOfRecord > 0 ? (
          <div className={"paginationContainer"}>
            <PaginationControlled
              tableLength={numberOfRecord}
              updateRowCount={this.updateRowCount}
              pageNo={pageNo}
              rowsPerPagination={rowsPerPagination}
            />
          </div>
        ) :
        <></>}
        <Dialog
          open={viewAll || false}
          onClose={() => this.handleViewAllData(false, "", "")}
          PaperComponent={PaperComponent}
          fullWidth
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "10px", flex: "1" }}
              >
                {header}
              </Typography>
              <IconButton
                title={"Close"}
                edge={"end"}
                color={"inherit"}
                onClick={() => this.handleViewAllData(false, "", "")}
                aria-label={"close"}
                className={"white-button"}
              >
                <IoMdCloseCircleOutline />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            {selectedData &&
              sortArray(
                removeDuplicates(selectedData.split(","))
              )?.map((obj, index) => (
                <Chip
                  key={"chip" + index + "c"}
                  label={obj}
                  style={{ margin: 1, fontSize: "0.7rem", height: "1.8rem" }}
                />
              ))}
          </DialogContent>
          <DialogActions>
            <Button
              color={"primary"}
              onClick={() => this.handleViewAllData(false, "", "")}
            >
              {"Close\r"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withRouter(CommunicationTable);
